<template>

<core-filter-advanced-group title="Tags" :count="count" :label="label">

	<p v-if="!isOwner && tags.length">The following tags have been made public by the owner of this collection.</p>
	
	<p v-if="!tags.length">There are no tags available for this collection.</p>

	<core-filter-input-toggles :colour="tag.colour" :text="tag.text" :subtext="tag.subtext" :icons="toggle.icons" :labels="toggle.labels" :values="toggle.values" :posneg="tag.id" :filter="value('tags')" v-for="tag in tags" :key="tag.id" />

</core-filter-advanced-group>

</template>

<script>

import Group from 'core/mixin/filter/Group.js'

export default {

	mixins: [Group],

	data: function() {

		return {

			fields: ['tags'],

			toggle: {

				icons: [false, false, 'arrows-alt-h', false],
				values: [3, 1, 0, 2],
				labels: ['Must', 'Include', '', 'Exclude']

			}

		}

	},

	computed: {

		tags: function() {

			var tags = []

			this.$_.each(this.$store.getters['data/tags/list'], function(tag) {

				var subtext = false

				if(tag.family) {

					var family = this.$store.getters['data/tagFamilies/associated'][tag.family]

					subtext = family.name

				}

				tags.push({
					id: tag.id,
					text: tag.text,
					colour: tag.colour,
					subtext: subtext
				})

			}.bind(this))

			return tags

		}

	}

}

</script>